import {
  Box,
  Button,
  Popover,
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import AddShoppingCartOutlinedIcon from '@mui/icons-material/AddShoppingCartOutlined';
import React, { useEffect, useState } from "react";
import restype from "../../assets/restype.png";
import { useDispatch, useSelector } from "react-redux";
import {
  setReservationGroupDatas,
  updateReservationGroup,
} from "../../store/slice/Addguest.slice";
import { getReservationGroup } from "../../api/HorecaWidget.service";
import dayjs from "dayjs";
import ShowMoreLessText from "./ShowMoreLessText";
import AddCircleTwoToneIcon from '@mui/icons-material/AddCircleTwoTone';

const ReservationGroup = ({ isOpen, handleClose, Ref }) => {
  const theme = useTheme();
  const [showMore, setShowMore] = useState(false);
  const matchesXs = useMediaQuery(theme.breakpoints.down("xs")); // For small devices
  const matchesSm = useMediaQuery(theme.breakpoints.down("sm")); // For tablets and up
  const {
    reservType,
    selectedDate,
    time,
    reservationGroupData,
    reservGroup,
    isBackToHoreca,
    defaultLanguage,
    languageWords,
  } = useSelector((store) => store?.addGuest);
  const { key } = useSelector((store) => store?.widgetSettings);
  const dispatch = useDispatch();


  return (
    <Popover
      open={isOpen}
      anchorEl={Ref}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: matchesSm ? "93%" : "100%",
          maxWidth: "850px",
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: theme?.resType?.bgColor,
          width: { xs: "100%", sm: "100%", md: "100%" },  // Responsive width
          p: 3,
          display: "flex",
          flexDirection: "column",
         
          gap: "1rem",
        //  minHeight:"200px"
        }}
      >
        {reservationGroupData?.map((item, i) => (
          <Box
            key={i}
            sx={{
              display: "flex",
              gap: "0.5rem",
             height:"100%",
             p:2,
              backgroundColor:
                reservGroup?.idarrangementtype === item?.idarrangementtype
                  ? theme?.resType?.itemBgActive
                  : theme?.resType?.itemBgColor,
              border: `1px solid ${theme?.resType?.borderColor}`,
              color:
                reservGroup?.idarrangementtype === item?.idarrangementtype
                  ? theme?.resType?.textColorActive
                  : theme?.resType?.itemTextColor,
              p: 1,
              borderRadius: "8px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: theme?.resType?.itemBgHover,
                color: theme?.resType?.textHover,
              },
            }}
        
          >
            <Box sx={{width:"100%"}}>
              <Box sx={{display:"flex",justifyContent:"space-between"}}>
              <Typography
                sx={{
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  
                }}
              >
                {item?.name}
              </Typography>
              {!item?.info && <Button
                  variant="contained"
                  size="small"
                  sx={{
                    backgroundColor:
                      reservGroup?.idarrangementtype === item?.idarrangementtype
                        ? theme?.resType?.chooseBgActive
                        : theme?.resType?.chooseBg,
                    color:
                      reservGroup?.idarrangementtype === item?.idarrangementtype
                        ? theme?.resType?.chooseTextActive
                        : theme?.resType?.chooseText,
                    "&:hover": {
                      backgroundColor: theme?.resType?.chooseBgHover,
                      color: theme?.resType?.chooseTextHover,
                    },
                    width: "60px",
                    height: "30px",
                    fontSize: "10px",
                    borderRadius: "7px",
                    ml: 1, // Added margin for spacing
                  }}
                  onClick={() => {
                    dispatch(updateReservationGroup(item));
                    handleClose();
                  }}
                >
                  {languageWords?.choose}
                </Button>}
              </Box>
                {item?.info && <ShowMoreLessText text={ item?.info}  setIsShowMore={()=>setShowMore(!showMore)} isShowMore={showMore}/>}
              {item?.info && <Box
                sx={{
                  display: "flex",

                  justifyContent: "flex-end",
                
                }}
              >
                <IconButton
                
                  size="small"
                  sx={{
                    backgroundColor:
                      reservGroup?.idarrangementtype === item?.idarrangementtype
                        ? theme?.resType?.chooseBgActive
                        : theme?.resType?.chooseBg,
                    color:
                      reservGroup?.idarrangementtype === item?.idarrangementtype
                        ? theme?.resType?.chooseTextActive
                        : theme?.resType?.chooseText,
                    "&:hover": {
                      backgroundColor: theme?.resType?.chooseBgHover,
                      color: theme?.resType?.chooseTextHover,
                    },
                    
                    borderRadius:"5px",
                    ml: 1, // Added margin for spacing
                  }}
                  onClick={() => {
                    dispatch(updateReservationGroup(item));
                    handleClose();
                  }}
                >
                  <AddCircleTwoToneIcon />
                </IconButton>
              </Box>}
            </Box>
          </Box>
        ))}
      </Box>
    </Popover>
  );
};

export default ReservationGroup;
